<template>
  <v-dialog max-width="1000px" scrollable :value="value" @input="toggleModal()">
    <v-card color="kbLight" height="500px">
      <v-toolbar color="kbLight" flat>
        <span class="text-h5 d-block pl-3 pt-3 kbDarkBlueText--text text-capitalize font-weight-medium">
          {{ $t('general.createSequence') }}
        </span>
        <v-spacer></v-spacer>
        <v-btn color="kbDarkBlueText" icon @click="toggleModal()">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="kbLight"
               align="center"
               justify="center"
               no-gutters>
          <v-col cols="12" md="9">
            <v-row>
              <v-col cols="12"
                     md="4"
                     v-for="(creationMethod, index) in creationMethods"
                     :key="index">
                <div class="creation-method-card
                            kbWhite
                            d-flex
                            flex-column
                            align-center
                            justify-center
                            elevation-3"
                     @click="creationMethod.action()">
                  <v-icon :color="creationMethod.icon.color"
                          size="60px">
                    {{ creationMethod.icon.name }}
                  </v-icon>
                  <span class="kbDarkBlueText--text d-block text-uppercase text-center">
                {{ creationMethod.name }}
              </span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

  </v-dialog>
</template>

<script>
export default {
  computed: {
    creationMethods () {
      const vue = this
      return [
        { name: 'New', icon: { name: 'mdi-sitemap', color: 'kbPink' }, action () { vue.showNewSequenceDialog() } },
        { name: 'Clone', icon: { name: 'mdi-sitemap', color: 'kbGreen', action () {} } },
        { name: 'From template', icon: { name: 'mdi-sitemap', color: 'kbGreen', action () {} } }
      ]
    }
  },
  methods: {
    showNewSequenceDialog () {
      this.toggleModal()
      this.$emit('showNewSequenceDialog')
    },
    toggleModal () {
      this.$emit('input', false)
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
  .creation-method-card {
    cursor: pointer;
    height: 180px;
    transition: all ease-in-out 0.3s;
  }
  .creation-method-card:hover {
    transform: scale(1.03);
    background-color: white;
  }
</style>
